import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { HomeService } from './home.service';
import { HomeEffects } from './home.effects';
import { StoreModule } from '@ngrx/store';
import { HomeFeature, homeReducer } from './home.reducer';

@NgModule({
  imports: [
    EffectsModule.forFeature([HomeEffects]),
    StoreModule.forFeature(HomeFeature, homeReducer),
  ],
  providers: [HomeService],
})
export class HomeModule {}
